/** UI 언어(ko/en) 저장 키 — plugins/i18n.js 와 동일 */
export const LOCALE_STORAGE_KEY = 'language';

const ALLOWED = new Set(['ko', 'en']);

/**
 * 저장된 언어 → 없으면 브라우저 언어(한국어면 ko, 그 외 en)
 * @returns {'ko'|'en'}
 */
export function resolveInitialLocale() {
  if (typeof localStorage !== 'undefined') {
    const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
    if (ALLOWED.has(stored)) {
      return stored;
    }
  }

  const browserLang =
    (typeof navigator !== 'undefined' &&
      (navigator.languages?.[0] || navigator.language || navigator.userLanguage)) ||
    '';
  return String(browserLang).toLowerCase().startsWith('ko') ? 'ko' : 'en';
}

/**
 * 앱 i18n·Vuetify 내장 문구 로케일을 함께 맞춘다.
 * @param {import('vue-i18n').default} i18n
 * @param {import('vuetify').default} vuetify
 * @param {'ko'|'en'} locale
 * @param {{ forceReload?: boolean }} [options]
 */
export function setAppLocale(i18n, vuetify, locale, options = {}) {
  const code = ALLOWED.has(locale) ? locale : 'ko';
  const prevLocale = i18n?.locale;
  const forceReload = options.forceReload !== false;

  if (prevLocale === code) {
    localStorage.setItem(LOCALE_STORAGE_KEY, code);
    return;
  }

  i18n.locale = code;
  localStorage.setItem(LOCALE_STORAGE_KEY, code);
  if (vuetify?.lang) {
    vuetify.lang.current = code;
  }

  // 일부 레거시 컴포넌트의 width/height 계산 갱신 유도
  if (typeof window !== 'undefined') {
    requestAnimationFrame(() => {
      window.dispatchEvent(new Event('resize'));
      if (forceReload) {
        window.location.reload();
      }
    });
  }
}
